import { getBseUrl } from '@/constants';
import { request } from '@umijs/max';
let BASEURL = getBseUrl();

export async function pageByCategoryId(params, options) {
  const _params = {
    ...params,
    status: 0,
    processStatus: 2,
  }
  return request(`${BASEURL}/con/content/pageByCategoryId`, {
    method: 'GET',
    params: {
      ..._params,
    },
    ...(options || {}),
  });
}

export async function getContentInfo(params, options) {
  return request(`${BASEURL}/con/content/getContentInfo/${params?.id}`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
